import { render, staticRenderFns } from "./block8.vue?vue&type=template&id=b29e2944&"
import script from "./block8.vue?vue&type=script&lang=js&"
export * from "./block8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports